// 门窗
import rlModelData from "./rlModelData";
import store from "@/store/index";
import { getEntityData } from "@/rlMxModules/operate/operateApi";
import { getPKPM_DoorsWindowsData } from "@/rlMxModules/Opencascad/getModelDrawData";
import {
  McGePoint3d,
  McDbPolyline,
  McCmColor,
  McDbEllipse,
  McGeVector3d,
} from "mxcad";
import { MovePt } from "../operate/structural";
import { log } from "three";
class rlDoorsWindowsData extends rlModelData {
  getModel3dData = store.state.globalData.rl_wasm_module.getModel3dData;
  // wasm接口方法
  // getPKPM_WallHoleData =
  //   store.state.globalData.rl_wasm_module.getPKPM_WallHoleData;
  constructor() {
    super();
    this.componentType = "DoorsWindows";
    this.points = []; // 顶点数据
    this.deviation = 0;

    this.m_partitionWallData = {}; //关联的隔墙数据
    // this.m_sectParamData = {}; //墙截面数据
    // this.SectData = []; //墙截面组合数据

    this.m_partitionWallThick = 0; //墙洞所在墙的墙厚
    this.m_partitionWallEcc = 0; //墙洞所在墙的偏轴

    this.Ecc = null; //洞口定位距离
    this.HDiff = null; //洞口底部标高

    this.classTypeName = "rlDoorsWindows"; // 门窗
    this.Mat = null; //材料
    this.MatName = ""; //材料名称
    this._threeObj = null; ////三维图形对象

    this.Color = null;
    this.ModelType = "门窗";
    this.m_groupName = "rlDoorsWindowsGroup"; //组名
    this.doorsWindowsType = null; //门窗竖向,1==门,0==窗,2==洞
    this.isWasmGeted = false; //是否已经获取wasm数据
    this.nonStructural = true; //非结构构件标识
    this.startPoint = null;
    this.endPoint = null;
    this.otherDrawIds = []; //门窗的内填充(并非真的填充,是额外绘制多段线)
    this.draw2dData = {}; //绘制2维数据
  }

  initData(obj) {
    super.initData(obj);
    let tempOtherData = JSON.parse(this.OtherData);
    this.startPoint = new McGePoint3d(
      tempOtherData.startPoint.x,
      tempOtherData.startPoint.y,
      0
    );
    this.endPoint = new McGePoint3d(
      tempOtherData.endPoint.x,
      tempOtherData.endPoint.y,
      0
    );
    this.m_partitionWallData = obj.m_partitionWallData;
    this.m_partitionWallThick = obj.m_partitionWallThick; //墙洞所在墙的墙厚
    this.m_partitionWallEcc = obj.m_partitionWallEcc; //墙洞所在墙的偏轴
    // const wallSect = obj.wallSect;
    this.Ecc = obj.Ecc; //洞口定位距离
    this.HDiff = obj.HDiff; //洞口底部标高
    this.doorsWindowsType = obj.doorsWindowsType;
    this.Color = obj.Color;
    this.Mat = obj.Mat;
    //与网格数据绑定
    if (
      this.m_partitionWallData.classTypeName == "rlPartitionWallSeg" &&
      !this.m_partitionWallData.m_HoleIdArray.includes(this.Guid)
    ) {
      this.m_partitionWallData.m_HoleIdArray.push(this.Guid);
    }
    this.index2dData = obj.index2dData;
    this.index3dData = obj.index3dData;
    this.points = obj.points;
    this.setMatName();
  }

  setMatName() {
    switch (this.Mat) {
      case 52:
        this.MatName = "玻璃";
        break;
      case 53:
        this.MatName = "金属";
        break;
      case 54:
        this.MatName = "轻质材料";
        break;
      case 55:
        this.MatName = "人造板材";
        break;
      case 56:
        this.MatName = "其他材料";
        break;
      default:
        this.MatName = "";
        break;
    }
  }

  updateThisObj(obj, redraw = true) {
    super.updateThisObj(obj, redraw);
    this.m_partitionWallData.drawBreakWall();
    this.setMatName();
  }

  //绘制窗样式
  drawWindowStyle() {
    if (!this.draw2dData) return;
    let interval = this.m_partitionWallThick / 3;
    let startPt = this.draw2dData.ptLongStart;
    let endPt = this.draw2dData.ptLongEnd;
    startPt = MovePt(startPt, this.draw2dData.vecShort, interval);
    endPt = MovePt(endPt, this.draw2dData.vecShort, interval);
    let line1 = new McDbPolyline();
    line1.addVertexAt(startPt);
    line1.addVertexAt(endPt);
    line1.setxDataString("Guid", this.Guid);
    line1.setxDataString("classTypeName", this.classTypeName);
    line1.trueColor = new McCmColor(this.Color.r, this.Color.g, this.Color.b);
    let polylineMcDb1 = rlAppObj.mxcadObject.drawEntity(line1);
    this.otherDrawIds.push(polylineMcDb1);
    startPt = MovePt(startPt, this.draw2dData.vecShort, interval);
    endPt = MovePt(endPt, this.draw2dData.vecShort, interval);
    let line2 = new McDbPolyline();
    line2.addVertexAt(startPt);
    line2.addVertexAt(endPt);
    line2.setxDataString("Guid", this.Guid);
    line2.setxDataString("classTypeName", this.classTypeName);
    line2.trueColor = new McCmColor(this.Color.r, this.Color.g, this.Color.b);
    let polylineMcDb2 = rlAppObj.mxcadObject.drawEntity(line2);
    this.otherDrawIds.push(polylineMcDb2);
  }

  //绘制门样式
  drawDoorStyle() {
    if (!this.draw2dData) return;
    let visible = store.state.displayData.doorsDisplay;

    // 获取门的基本点位和向量
    let ptLongStart = this.draw2dData.ptLongStart;
    let ptLongEnd = this.draw2dData.ptLongEnd;
    let vecShort = this.draw2dData.vecShort;

    // 计算门的长度作为弧的半径
    let radius = ptLongStart.distanceTo(ptLongEnd);

    // 创建门扇多段线
    let doorLeaf = new McDbPolyline();

    // 添加起点
    doorLeaf.addVertexAt(ptLongStart);

    // 计算弧线的点，使用vecShort的方向，并反转方向
    let segments = 16; // 弧线分段数
    for (let i = 0; i <= segments; i++) {
      let angle = (Math.PI / 2) * (i / segments);
      let x =
        ptLongStart.x +
        radius * vecShort.x * Math.cos(angle) -
        radius * vecShort.y * Math.sin(angle);
      let y =
        ptLongStart.y +
        radius * vecShort.y * Math.cos(angle) +
        radius * vecShort.x * Math.sin(angle);
      doorLeaf.addVertexAt(new McGePoint3d(x, y, 0));
    }

    doorLeaf.setxDataString("Guid", this.Guid);
    doorLeaf.setxDataString("classTypeName", this.classTypeName);
    doorLeaf.trueColor = new McCmColor(
      this.Color.r,
      this.Color.g,
      this.Color.b
    );
    doorLeaf.visible = visible;

    let doorLeafMcDb = rlAppObj.mxcadObject.drawEntity(doorLeaf);
    this.otherDrawIds.push(doorLeafMcDb);
  }

  getEllipsePoints(ptStart, ptEnd) {
    // 已知参数
    const P1 = ptStart; // 起点（请替换 x1 和 y1）
    const P2 = ptEnd; // 终点（请替换 x2 和 y2）
    const cx = (P1.x + P2.x) / 2;
    const cy = (P1.y + P2.y) / 2;
    const center = new McGePoint3d(cx, cy); // 圆心（请替换 cx 和 cy）

    // 计算主轴和副轴
    const dx = P2.x - P1.x;
    const dy = P2.y - P1.y;
    const length = Math.hypot(dx, dy);
    const ux = dx / length;
    const uy = dy / length;

    // 主轴长度和向量
    const A = length / 2; // 主轴长度
    const majorAxis = new McGeVector3d(ux * A, uy * A, 0);

    // 副轴长度和方向（垂直于主轴）
    const vx = -uy;
    const vy = ux;
    const B = A * 0.2; // 调整此值以改变椭圆的扁平程度
    const minorAxis = new McGeVector3d(vx * B, vy * B, 0);

    // 计算起始角度和结束角度
    function computeAngle(P, center, majorAxis, minorAxis) {
      const dx = P.x - center.x;
      const dy = P.y - center.y;

      const A_length = Math.hypot(majorAxis.x, majorAxis.y);
      const B_length = Math.hypot(minorAxis.x, minorAxis.y);
      const u = { x: majorAxis.x / A_length, y: majorAxis.y / A_length };
      const v = { x: minorAxis.x / B_length, y: minorAxis.y / B_length };

      const x = dx * u.x + dy * u.y;
      const y = dx * v.x + dy * v.y;

      return Math.atan2(y / B_length, x / A_length);
    }

    const startAngle = computeAngle(P1, center, majorAxis, minorAxis);
    let endAngle = computeAngle(P2, center, majorAxis, minorAxis);
    if (endAngle < startAngle) {
      endAngle += 2 * Math.PI;
    }

    // 生成点集
    const numPoints = 20; // 点的数量
    const points = [];
    for (let i = 0; i <= numPoints; i++) {
      const t = startAngle + ((endAngle - startAngle) * i) / numPoints;
      const x =
        center.x + majorAxis.x * Math.cos(t) + minorAxis.x * Math.sin(t);
      const y =
        center.y + majorAxis.y * Math.cos(t) + minorAxis.y * Math.sin(t);
      points.push(new McGePoint3d(x, y));
    }
    return points;
  }

  // 计算起始角度和结束角度
  computeAngle(P, center, majorAxis, minorAxis) {
    // 将点转换到椭圆的坐标系
    const dx = P.x - center.x;
    const dy = P.y - center.y;

    // 规范化主轴和副轴向量
    const A_length = Math.hypot(majorAxis.x, majorAxis.y);
    const B_length = Math.hypot(minorAxis.x, minorAxis.y);
    const u = { x: majorAxis.x / A_length, y: majorAxis.y / A_length };
    const v = { x: minorAxis.x / B_length, y: minorAxis.y / B_length };

    // 计算在椭圆坐标系中的坐标
    const x = dx * u.x + dy * u.y;
    const y = dx * v.x + dy * v.y;

    // 计算角度
    return Math.atan2(y / B_length, x / A_length);
  }

  getDraw2dData() {
    if (!this.index2dData) return;

    this.eraseOtherDraw();
    let ptArray = [];
    for (let i = 0; i < this.index2dData.length; i += 3) {
      ptArray.push(
        new McGePoint3d(this.index2dData[i], this.index2dData[i + 1], 0)
      );
    }
    if (ptArray.length != 4) return;
    let pt0 = ptArray[0];
    let pt1 = ptArray[1];
    let pt2 = ptArray[2];
    let pt3 = ptArray[3];
    let dist1 = pt0.distanceTo(pt1);
    let dist2 = pt0.distanceTo(pt3);
    //获取短板和长边的点位,以及方向向量
    if (dist1 === this.m_sectParamData.B) {
      this.draw2dData.ptLongStart = pt0;
      this.draw2dData.ptLongEnd = pt1;
      this.draw2dData.vecLong = new THREE.Vector3()
        .subVectors(pt0, pt1)
        .normalize();
      this.draw2dData.ptShortStart = pt1;
      this.draw2dData.ptShortEnd = pt2;
      this.draw2dData.vecShort = new THREE.Vector3()
        .subVectors(pt2, pt1)
        .normalize();
    } else {
      this.draw2dData.ptShortStart = pt3;
      this.draw2dData.ptShortEnd = pt0;
      this.draw2dData.vecShort = new THREE.Vector3()
        .subVectors(pt0, pt3)
        .normalize();
      this.draw2dData.ptLongStart = pt2;
      this.draw2dData.ptLongEnd = pt3;
      this.draw2dData.vecLong = new THREE.Vector3()
        .subVectors(pt2, pt3)
        .normalize();
    }
    this.draw2dData.ptLongCenterStart = MovePt(
      this.draw2dData.ptLongStart,
      this.draw2dData.vecShort,
      this.m_partitionWallThick / 2
    );
    this.draw2dData.ptLongCenterEnd = MovePt(
      this.draw2dData.ptLongEnd,
      this.draw2dData.vecShort,
      this.m_partitionWallThick / 2
    );
  }

  // 数据转换
  convert() {
    if (!this.isWasmGeted || (!this.index2dData && !this.index3dData)) {
      let res = getPKPM_DoorsWindowsData(
        this.startPoint.x,
        this.startPoint.y,
        this.endPoint.x,
        this.endPoint.y,
        Number(this.m_sectParamData.B),
        Number(this.m_sectParamData.H),
        Number(this.m_partitionWallThick),
        Number(this.m_partitionWallEcc),
        Number(this.Ecc),
        Number(this.HDiff),
        Number(this.LevelB)
      );
      if (!res) return;
      res = JSON.parse(res);
      res.startPoint = {
        x: this.startPoint.x,
        y: this.startPoint.y,
        z: 0,
      };
      res.endPoint = {
        x: this.endPoint.x,
        y: this.endPoint.y,
        z: 0,
      };
      this.getModelDrawData(res);

      // let wasmData = JSON.parse(res);
      // let data = `{"${this.Guid}":${JSON.stringify(wasmData)}}`;
      // let data3D = this.getModel3dData(data);
      // if (!data3D) return;

      // data3D = JSON.parse(data3D)["3D"][this.Guid];
      // this.points = data3D.Points;
      // this.index3dData = {
      //   points: data3D.Points,
      //   faces: data3D["3dFaces"].map((item) => item.index).flat(),
      // };
    } else {
      if (!Array.isArray(this.index2dData)) {
        this.index2dData = this.index2dData.split(",").map(Number);
      }
    }
    // this.m_sectGroupName = this.m_sectParamData.B.toString();
    this.getDraw2dData();
    if (this.doorsWindowsType === 1) {
      this.drawDoorStyle();
    } else {
      this.drawWindowStyle();
    }
  }

  // wasm截面数据转换
  // getModelDrawData(modelData) {
  //   // this.index3dData = modelData["3D"]["3dFaces"]
  //   //   .map((item) => item.index)
  //   //   .flat();
  //   this.index2dData = modelData["2DUpView"];
  //   this.SectData = modelData["SectData"];
  //   this.OtherData = JSON.stringify(modelData);
  // }

  draw() {
    if ((!this.index2dData && !this.index3dData) || !this.isWasmGeted) {
      this.isWasmGeted = false;
      this.convert();
    }
    this.m_sectGroupName =
      this.m_sectParamData.B + "*" + this.m_sectParamData.H;
    this.CurrtSect = this.m_sectGroupName + "*" + this.m_partitionWallThick; //增加墙厚尺寸
    super.draw();
    if (this.mcDbPolyline) {
      this.mcDbPolyline.setxDataString(
        "doorsWindowsType",
        this.doorsWindowsType
      );
      if (this.doorsWindowsType === 1) this.mcDbPolyline.visible = false;
    }

    // this.m_partitionWallData
    //   ? this.m_partitionWallData.m_HoleIdArray.push(this.Guid)
    //   : "";
  }

  // 克隆
  myClone() {
    let newObj = new rlDoorsWindowsData();
    super.cloneData(newObj);

    newObj.m_partitionWallData = this.m_partitionWallData;
    newObj.Ecc = this.Ecc;
    newObj.HDiff = this.HDiff;
    newObj.doorsWindowsType = this.doorsWindowsType;
    newObj.m_partitionWallEcc = this.m_partitionWallEcc;
    newObj.m_partitionWallThick = this.m_partitionWallThick;
    newObj.Color = this.Color;
    newObj.points = this.points;
    newObj.startPoint = this.startPoint;
    newObj.endPoint = this.endPoint;
    newObj.OtherData = this.OtherData;
    //与网格数据绑定
    newObj.m_partitionWallData.m_HoleIdArray.push(newObj.Guid);
    return newObj;
  }

  getDataBase() {
    let data = super.getDataBase();
    data["SectGuid"] = this.m_sectParamData.Guid;

    if (this.m_partitionWallData)
      data["GridGuid"] = this.m_partitionWallData.Guid;
    data["Drawing_2D"] = this.index2dData.join(",");
    data["Drawing_3D"] = JSON.stringify(this.index3dData);
    data["Mat"] = this.Mat;
    data["DoorsWindowsType"] = this.doorsWindowsType;
    //data["OtherData"] = this.OtherData;
    data["Ecc"] = this.Ecc;
    data["HDiff"] = this.HDiff;
    return data;
  }
  //用于撤销回退
  reDraw(obj) {
    super.reDraw(obj);

    let tempOtherData = JSON.parse(this.OtherData);
    this.startPoint = new McGePoint3d(
      tempOtherData.startPoint.x,
      tempOtherData.startPoint.y,
      0
    );
    this.endPoint = new McGePoint3d(
      tempOtherData.endPoint.x,
      tempOtherData.endPoint.y,
      0
    );
    this.m_partitionWallData = getEntityData({
      Guid: obj.m_partitionWallData,
      classTypeName: "rlGrid",
    }); //obj.m_partitionWallData.mcDbGridId.getMcDbEntity();
    this.m_partitionWallThick = obj.m_partitionWallThick; //墙洞所在墙的墙厚
    this.m_partitionWallEcc = obj.m_partitionWallEcc; //墙洞所在墙的偏轴
    // const wallSect = obj.wallSect;
    this.Ecc = obj.Ecc; //洞口定位距离
    this.HDiff = obj.HDiff; //洞口底部标高
    this.doorsWindowsType = obj.doorsWindowsType;
    this.Mat = obj.Mat;
    this.setMatName();
  }

  //获取图形绘制数据--用于撤销回退
  getDrawData() {
    let data = super.getDrawData();

    data["m_gridData"] = this.m_partitionWallData
      ? this.m_partitionWallData.Guid
      : "";
    data["Ecc"] = this.Ecc;
    data["HDiff"] = this.HDiff;
    data["m_partitionWallThick"] = this.m_partitionWallThick; //墙洞所在墙的墙厚
    data["m_partitionWallEcc"] = this.m_partitionWallEcc; //墙洞所在墙的偏轴
    data["doorsWindowsType"] = this.doorsWindowsType;
    data["Mat"] = this.Mat;
    return data;
  }

  eraseOtherDraw() {
    this.otherDrawIds.forEach((item) => {
      if (item) {
        item.erase();
      }
    });
  }

  // 删除
  erase() {
    if (this.m_partitionWallData) {
      this.m_partitionWallData.m_HoleIdArray =
        this.m_partitionWallData.m_HoleIdArray.filter(
          (item) => item !== this.Guid
        );
      this.m_partitionWallData.drawBreakWall();
      if (this.m_partitionWallData.m_HoleIdArray.length === 0) {
        this.m_partitionWallData.mcDbId.getMcDbEntity().visible = true;
      }
    }
    this.eraseOtherDraw();
    super.erase();
  }
}

export { rlDoorsWindowsData };
